

import {getQueryString} from '@activity-business/h5-package-frameworkTool';/**
 * Created by Sam on 2019/3/21.
 */
(function (window) {
  function MicoJSBridge () {}
  let log = function (text) {
    return Promise.reject(new Error('MicoJSBridge: ' + text))
  }

  function promiseHandler (m, resolve, reject) {
    MicoJSBridge[m] = json => {
      try {
        let { success = false, ...result } = typeof json === 'string' ? JSON.parse(json) : typeof json === 'object' ? json : { success: true }
        if (success) {
          resolve(result)
        } else {
          reject(result)
        }
      } catch (error) {
        reject(error)
      }
    }
    return true
  }

  let injectObj = function (...args) {
    let _this = this

    if (args.length <= 0) {
      return
    }

    let isAndroid = navigator.userAgent.indexOf('Android') > -1 || navigator.userAgent.indexOf('Adr') > -1
    let isiOS = !!navigator.userAgent.match(/\(i[^;]+;( U)? CPU.+Mac OS X/)

    let androidObjName = ''
    let iOSObjName = ''

    let callBack = function (m) {
      return function (...args2) {
        if(getQueryString(CONFIG.prefetchProject.queryMark)) return log(`${location.href} - 预加载内嵌网页，不执行 jsBridge 方法!`);

        let args = Array.prototype.slice.apply(args2).map(arg => JSON.stringify(arg))
        if (isAndroid) {
          if (typeof window[androidObjName] !== 'undefined') {
            if (typeof window[androidObjName][m] !== 'undefined') {
              return new Promise((resolve, reject) => {
                if (promiseHandler(m, resolve, reject)) {
                  window[androidObjName][m].apply(window[androidObjName], args)
                }
              })
            } else {
              return log('android webview do not define method ' + m)
            }
          } else {
            return log('android webview do not define obj ' + androidObjName)
          }
        }

        if (isiOS) {
          if (iOSObjName !== '') {
            if (typeof window.webkit !== 'undefined' && typeof window.webkit.messageHandlers[iOSObjName] !== 'undefined') {
              let o1 = window.webkit.messageHandlers[iOSObjName]
              return new Promise((resolve, reject) => {
                if (promiseHandler(m, resolve, reject)) {
                  o1.postMessage({ method: m, parameter: args })
                }
              })
            } else {
              return log('ios webview do not define object ' + iOSObjName)
            }
          } else {
            if (typeof window.webkit !== 'undefined' && typeof window.webkit.messageHandlers[m] !== 'undefined') {
              let o2 = window.webkit.messageHandlers[m]
              return new Promise((resolve, reject) => {
                if (promiseHandler(m, resolve, reject)) {
                  o2.postMessage.apply(o2, args)
                }
              })
            } else {
              return log('ios webview do not define object ' + m)
            }
          }
        }

        return log('call in moblie webview')
      }
    }

    let addMethods = function (ms) {
      for (let i = 0; i < ms.length; i++) {
        _this[ms[i]] = callBack(ms[i])
      }

      if (isAndroid && typeof window[androidObjName] !== 'undefined') {
        let find = function (arr, e) {
          for (let i = 0; i < arr.length; i++) {
            if (arr[i] === e) {
              return true
            }
          }
          return false
        }

        for (let j in window[androidObjName]) {
          if (!find(ms, j)) {
            _this[j] = callBack(j)
          }
        }
      }
    }

    if (args.length === 2) {
      androidObjName = args[0]
      if (args[1] instanceof Array) {
        addMethods(args[1])
        return
      }
    } else if (args.length === 3) {
      androidObjName = args[0]
      iOSObjName = args[1]
      if (args[2] instanceof Array) {
        addMethods(args[2])
        return
      }
    }

    return log('parameters error!')
  }

  MicoJSBridge.create = function (...args) {
    let easy = new MicoJSBridge()
    injectObj.apply(easy, ['Android', 'iOS', ...args])
    return easy
  }

  window.MicoJSBridge = MicoJSBridge
})(window)

export default window.MicoJSBridge

export let {
  h5_obtainSupportedMethods: h5ObtainSupportedMethods,
  h5_obtainAccessToken: h5ObtainAccessToken,
  h5_obtainProfile: h5ObtainProfile,
  h5_exit: h5Exit,
  h5_open: h5Open,
  h5_openBrowser: h5OpenBrowser,
  h5_share: h5Share,
  h5_share_sugo: h5ShareSugo,
  h5_share_sugo_outside: h5ShareSugoOutside,
} = window.MicoJSBridge.create([
  "h5_obtainSupportedMethods",
  "h5_obtainProfile",
  "h5_obtainAccessToken",
  "h5_exit",
  "h5_open",
  "h5_openBrowser",
  "h5_share",
  "h5_share_sugo",
  "h5_share_sugo_outside",
])
